import { forwardRef } from 'react';
import { CheckboxProps } from '../../../types';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ 
    label,
    description,
    error,
    className = '',
    ...props 
  }, ref) => {
    const checkboxClasses = `h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded ${className}`;

    return (
      <div>
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              ref={ref}
              type="checkbox"
              className={checkboxClasses}
              {...props}
            />
          </div>
          {(label || description) && (
            <div className="ml-3 text-sm">
              {label && (
                <label htmlFor={props.id} className="font-medium text-gray-700 cursor-pointer">
                  {label}
                  {props.required && <span className="text-red-500 ml-1">*</span>}
                </label>
              )}
              {description && (
                <p className="text-gray-500">{description}</p>
              )}
            </div>
          )}
        </div>
        
        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox; 